module.exports = __webpack_public_path__ + "img/AFMS_CRASH.d5ca3954.png";